import { MediaAsset } from '@epicuro-next/data/merchandise';
import { createAction, props } from '@ngrx/store';

export const loadPersonalMediaItems = createAction(
  '[PersonalMedia] Load personal media items',
);

export const loadPersonalMediaItemsSuccess = createAction(
  '[PersonalMedia]  Load personal media items success',
  props<{ mediaItems: MediaAsset[] }>(),
);

export const loadPersonalMediaItemsError = createAction(
  '[PersonalMedia]  Load personal media items error',
  props<{ error: string }>(),
);

export const resetPersonalMediaItems = createAction(
  '[PersonalMedia] Reset personal media items',
);
